<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { RouterLink } from "vue-router";

import { useSiteFooter } from "@/composables";

import LeFooterLanguageSelector from "./LeFooterLanguageSelector.vue";

const { t } = useI18n();
const { languageSelectorOptions, changeSiteLanguage, trackFooterButtonClick } = useSiteFooter("simple");
</script>

<template>
  <div class="le-simple-footer">
    <div class="le-simple-footer__container container">
      <div class="le-simple-footer__section">
        <p class="mb-0">{{ t("le-simple-footer.copyright", { year: new Date().getFullYear() }) }}</p>
      </div>
      <div class="le-simple-footer__section">
        <RouterLink
          class="le-simple-footer__link"
          :to="{ name: 'terms' }"
          @click="trackFooterButtonClick('Terms and conditions of sale')"
          >{{ t("le-simple-footer.terms") }}</RouterLink
        >
        <RouterLink
          class="le-simple-footer__link"
          :to="{ name: 'policies' }"
          @click="trackFooterButtonClick('Cookies and privacy')"
          >{{ t("le-simple-footer.cookie") }}</RouterLink
        >
        <RouterLink class="le-simple-footer__link" :to="{ name: 'support' }" @click="trackFooterButtonClick('Help')">{{
          t("le-simple-footer.support")
        }}</RouterLink>
        <div class="le-simple-footer__site-language-selector">
          <LeFooterLanguageSelector :options="languageSelectorOptions" @change="changeSiteLanguage($event)" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all.less";

.le-simple-footer {
  background: @colors[@secondary][500];

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 32px;

    &::before,
    &::after {
      display: none;
    }

    @media screen and (min-width: 992px) {
      flex-direction: row;
      padding: 16px;
    }
  }

  &__section {
    display: grid;
    grid-template-columns: 1fr;
    font-size: 1rem;
    text-align: center;
    justify-items: center;

    @media screen and (min-width: 992px) {
      display: flex;
      align-items: center;
    }

    &:last-of-type {
      gap: 30px;
      justify-content: flex-end;
      order: -1;
      margin-bottom: 48px;

      @media screen and (min-width: 992px) {
        order: 0;
        margin-bottom: 0;
      }
    }
  }

  &__link {
    &:hover,
    &:focus {
      color: inherit;
      text-decoration: underline;
    }
  }

  &__site-language-selector {
    width: 100%;
    max-width: 164px;
  }
}
</style>
